export const setSearchTextForSurveyPage = (state,payload)=>{
    return{
        ...state,
        searchText : payload
    }
}
